import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { Hero } from "@/components/home/Hero";
import { TheBook } from "@/components/home/TheBook";
import { LittleDetails } from "@/components/home/LittleDetails";
import { HowItWorks } from "@/components/home/HowItWorks";
import { MadeFor } from "@/components/home/MadeFor";
import { BookOptions } from "@/components/home/BookOptions";
import { TrustAndFaq } from "@/components/home/TrustAndFaq";
import { FinalInvitation } from "@/components/home/FinalInvitation";
import "@/styles/home.css";

export default function HomePage() {
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => { let active = true; api.get("/meta/options").then(({ data }) => { if (active) setMeta(data); }).catch(() => { if (active) setError(true); }); return () => { active = false; }; }, []);
  const price = meta?.products?.classic?.price;
  return <><SiteHeader/><main id="main-content" tabIndex={-1}>
    <Hero price={price}/>
    <TheBook price={price}/>
    <LittleDetails/>
    <HowItWorks/>
    <MadeFor/>
    <BookOptions price={price} addons={meta?.addons} error={error}/>
    <TrustAndFaq/>
    <FinalInvitation/>
  </main><SiteFooter/></>;
}
